import moment from 'moment';
import numeral from 'numeral';
import lowerCase from 'lodash.lowercase';
import startCase from 'lodash.startcase';

numeral.register('locale', 'en-words', {
    ...numeral.locales.en,
    abbreviations: {
        thousand: 'thousand',
        million: 'million',
        billion: 'billion',
        trillion: 'trillion'
    }
});
numeral.locale('en-words');

export const NA_DEFAULT = 'N/A';
export const DASH_DEFAULT = '-- --';

export const orNA = (fn, na = NA_DEFAULT) => (val) => (val ? fn(val) : na);

export const orNaTruthyZero = (fn, na = NA_DEFAULT) => (val) =>
    val || val === 0 ? fn(val) : na;

// @todo don't use the orNA funciton if you don't want NA
export const orYears = (val) => (val === NA_DEFAULT ? '' : ' Years');
export const orDays = (val) => (val === NA_DEFAULT ? '' : ' days');

const formatUTC = (date, fmt) => moment.utc(date, moment.ISO_8601).format(fmt);

export const displayWithCommas = (val) => Intl.NumberFormat().format(val);
export const formatWithCommasOrNA = orNA(displayWithCommas);

export const displayShortDate = (date) => {
    if (!date) {
        return date;
    }
    const d = moment.utc(date);
    return d.isValid() ? formatUTC(date, 'M/DD/YYYY') : date;
};

export const displayShortDateOrNA = orNA(displayShortDate);

export const displayShortDateShortYear = (date) => formatUTC(date, 'M/DD/YY');
export const displayShortDateLongYear = (date) => formatUTC(date, 'M/DD/YYYY');

export const displayYear = (date) => formatUTC(date, 'YYYY');
export const displayWrittenDate = (date) => formatUTC(date, 'MMMM D, YYYY');
export const displayWrittenDateTime = (date) =>
    formatUTC(date, 'MMMM D, YYYY hh:mm:ss A');

export const displayYearMonthDay = (date) => moment(date).format('YYYY-MM-DD');

export const roundUpTo = (to) => (num) => Math.ceil(num / to) * to;

export const displayCurrency = (num, places = 2) => {
    if (num > 999999999) {
        return `${numeral(num / 1000000000).format(
            `$0,0.${new Array(places + 1).join(0)}`
        )} billion`;
    }
    if (num > 999999) {
        return `${numeral(num / 1000000).format(
            `$0,0.${new Array(places + 1).join(0)}`
        )} million`;
    }
    return numeral(num).format(`$0,0.${new Array(places + 1).join(0)}`);
};

export const displayCurrencyOrDash = orNA(displayCurrency, DASH_DEFAULT);

export const displayCurrencyOrDashTruthyZero = orNaTruthyZero(
    displayCurrency,
    DASH_DEFAULT
);

export const displayCurrencyOrNA = orNA(
    displayCurrency
); /* used for fund snapshot market price value defaulting requirements */

export const displayCurrencyOrNATruthyZero = orNaTruthyZero(displayCurrency);

export const displayCurrencyShort = (num, places = 2) =>
    numeral(num).format(`$0,0.${new Array(places + 1).join(0)} a`);

/**
 * @TODO coalesce around either using
 * displayPerentage or displayPercent
 * no reason for both fns + confusing
 */

export const displayPercentage = (num, places = 2) =>
    numeral(num).format(`0.${new Array(places + 1).join(0)}%`);

export const displayPercentageOrNA = orNA(displayPercentage);

export const displayPercent = (num, places) =>
    displayPercentage(num / 100, places);

export const displayPercentOrNA = orNA(displayPercent);

export const displayPercentOrNaTruthyZero = orNaTruthyZero(displayPercent);

export const displayPercentOrDash = orNA(displayPercent, DASH_DEFAULT);

export const roundDecimal = (num) =>
    (Math.round((num + Number.EPSILON) * 100) / 100).toFixed(2);
export const roundDecimalOrNA = orNA(roundDecimal);
export const roundDecimalOrNATruthyZero = orNaTruthyZero(roundDecimal);
export const roundDecimalOrDash = orNA(roundDecimal, DASH_DEFAULT);
export const roundDecimalOrDashTruthyZero = orNaTruthyZero(
    roundDecimal,
    DASH_DEFAULT
);

export const displayFirstUpperCase = (name) => startCase(lowerCase(name));

export const displaySign = (num) => (num > 0 ? '+' : '');

export const displayDecimalWithPlace = (places) => (num) => num.toFixed(places);

export const displayDecimalWithPlaceOrDash = (places) =>
    orNA(displayDecimalWithPlace(places), DASH_DEFAULT);

export const displayWithTwoDecimalOrDash = displayDecimalWithPlaceOrDash(2);

export const setCardID = (name, errPage) => {
    if (!name) return null;
    if (name.includes('-')) return name;

    // handles names from CARD_NAMES values in constants.js
    if (name.includes(' ')) {
        return `${name
            .split(' ')
            .join('-')
            .toLowerCase()}${errPage ? `-error` : `-card`}`;
    }

    // handles names passed in by card object
    const nameArr = name.match(/[A-Z][a-z]+/g);
    nameArr.pop();
    return `${nameArr.join('-').toLowerCase()}${errPage ? `-error` : `-card`}`;
};
export const tackFootnoteSymbol = (val) => parseInt(val, 10) >= 40;
